import AScene from "../../library/ExtendedObjects/AScene.js";
import gameData from "../../gameData.js";
import Backgrounds from "../Backgrounds.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class Intro extends AScene
{
    create()
    {
        this.background = new Backgrounds(this);
        this.background.displayBG(gameData.backgroundClasses.moneyBG, true);
        
        this.config = ABCyaLib.Environment.instance.gameConfig;

        if(this.config.subtitle) {
          this.countingCoins = [
            {
              key: "C_S",
              x: 125, y: 650,
              scale: 1.2
          },{
              key: "O_S",
              x: 260, y: 605,
              scale: .9
          },{
              key: "U_C",
              x: 370, y: 590,
              scale: .85
          },{
              key: "N_S",
              x: 475, y: 580,
              scale: .95
          },{
              key: "T_C",
              x: 595, y: 580,
              scale: .9
          },{
              key: "I_S",
              x: 700, y: 600,
              scale: .85
          },{
              key: "N_C",
              x: 815, y: 625,
              scale: .85
          },{
            key: "G_S",
            x: 925, y: 660,
            scale: .9
        }
        ];

          this.sortingCoins = [
            {
                key: "S_S",
                x: 200, y: 650,
                scale: 1
            },{
                key: "O_S",
                x: 310, y: 605,
                scale: .75
            },{
                key: "R_C",
                x: 410, y: 590,
                scale: .75
            },{
                key: "T_S",
                x: 515, y: 580,
                scale: .82
            },{
                key: "I_S",
                x: 625, y: 590,
                scale: .75
            },{
                key: "N_C",
                x: 725, y: 620,
                scale: .75
            },{
                key: "G_S",
                x: 826, y: 660,
                scale: .82
            }
        ]
        } else {
          this.countingCoins = [
            {
                key: "C_S",
                x: 111.73066946299465, y: 660.6970172684457,
                scale: 1.2000000000000002
            },{
                key: "O_S",
                x: 240.70787571058008, y: 680.8383045525902,
                scale: .9
            },{
                key: "U_C",
                x: 350, y: 645.4065934065934,
                scale: .85
            },{
                key: "N_S",
                x: 465.43593281454093, y: 682.3987441130298,
                scale: .95
            },{
                key: "T_C",
                x: 585.4697279099288, y: 670.1083202511774,
                scale: .9
            },{
                key: "I_S",
                x: 704.3120113324871, y: 661.9026687598116,
                scale: .85
            },{
                key: "N_C",
                x: 816.4382876170503, y: 643.8178963893249,
                scale: .85
            },{
                key: "G_S",
                x: 922.5362694777123, y: 676.3704866562009,
                scale: .9
            }
        ];

          this.sortingCoins = [
            {
                key: "S_S",
                x: 171.73066946299465, y: 660.6970172684457,
                scale: 1.2000000000000002
            },{
                key: "O_S",
                x: 300.70787571058008, y: 680.8383045525902,
                scale: .85
            },{
                key: "R_C",
                x: 410, y: 645.4065934065934,
                scale: .85
            },{
                key: "T_S",
                x: 515.43593281454093, y: 682.3987441130298,
                scale: .92
            },{
                key: "I_S",
                x: 625.4697279099288, y: 670.1083202511774,
                scale: .85
            },{
                key: "N_C",
                x: 734.3120113324871, y: 661.9026687598116,
                scale: .85
            },{
                key: "G_S",
                x: 856.4382876170503, y: 683.8178963893249,
                scale: .92
            }
        ]
        }
        
        this.coinData = gameData.gameType == gameData.gameTypes.COUNTING ? this.countingCoins : this.sortingCoins;

        let pigShadow = this.addSpine(-500, this.mid.y + 155, "Pig", "GoldPig", true);
        pigShadow.spine.setScale(1.3);
        pigShadow.spine.skeleton.color = {r: 0, g: 0, b: 0, a: .4};
        
        let pig = this.addSpine(-500, this.mid.y + 140, "Pig", "GoldPig", true);
        pig.spine.setScale(1.3);

        let titleText = this.addImage(this.mid.x + 20, 230, "Title_Txt");
        titleText.alpha = 0;
        this.addTween(pig.spine, 2800, {x: this.mid.x}, Phaser.Math.Linear.Linear, ()=>{
            pig.setMixByName("GoldPig", "GoldPig_Idle", .3);
            pigShadow.setMixByName("GoldPig", "GoldPig_Idle", .3);
            pig.play("GoldPig_Idle", false);
            pigShadow.play("GoldPig_Idle", false);
            this.addDelay(200, ()=>{
                
                this.addTween(titleText, 500, {alpha: 1}, Phaser.Math.Easing.Sine.Out);
                this.playSound("title_coin_tween");
                for(let i = 0; i < this.coinData.length; i++)
                {
                    let idx = i;
                    this.addDelay(200 * i, ()=>{this.animatecoin(this.coinData[i], this.coinData.length - idx);});
                }
                this.addDelay(200 * this.coinData.length + 500, ()=>{ this.animatePlayButton(); });
            });
        });
        this.addTween(pigShadow.spine, 2800, {x: this.mid.x + 15}, Phaser.Math.Linear.Linear);

        if(this.config.subtitle) this.subtitle = this.addImage(this.mid.x, this.mid.y * 2 - 60, this.config.subtitle).setScale(0);

        this.titleSound = this.playSound("title_jingle");
    }

    animatePlayButton()
    {
        let playButton = this.addButton(530, 190, "Title_PlyBtn", ()=>{
            this.addTween(this.titleSound, 500, {volume: 0});
            this.animateOut();
        });
        this.addDropShadow(playButton, 7, 7);

        if(this.subtitle) this.addTween(this.subtitle, 500, {scale:.9}, Phaser.Math.Easing.Sine.InOut);
        
        this.addSquareMask([playButton, playButton.shadow], 435, 100, 200, 200, false);
        playButton.mask.invertAlpha = true;
        this.addTween(playButton, 400, {y: 60, scaleY: .5, scaleX: .5}, Phaser.Math.Easing.Sine.Out, ()=>{
            playButton.mask = null;
            this.addTween(playButton, 800, {y: 475, x: 921, scaleX: 1, scaleY: 1, easeParams: [.5, .5]}, "Back", ()=>{
                this.addTween(playButton, 500, {scaleX: 1.1, scaleY: 1.1, repeat: -1, yoyo: true, delay: 1000}, Phaser.Math.Easing.Sine.InOut);
            });
        });
    }

    animateOut()
    {
        let background = new Backgrounds(this);
        background.displayBG(gameData.backgroundClasses.moneyBG, false);
        background.setDepth(10);
        background.alpha = 0;
        this.addTween(background, 500, {alpha: 1}, Phaser.Math.Easing.Sine.Out, ()=>{
            gameData.numOfLevels = this.config.numOfLevels;
            if(this.config.denominationType != null){
              gameData.denominations = this.config.denominationType;
              this.scene.start("Descriptions");
            }
            else this.scene.start('Menu');
        });
        this.add.existing(background);
    }

    animatecoin(coinData, depth)
    {
        let coinShadow = this.addSpine(530, 190, "coin", "flipForward", true);
        this.coinAnim = coinShadow.play("flipForward", false).timeScale = 3;
        coinShadow.setSkin(coinData.key);
        coinShadow.spine.setDepth(depth);
        coinShadow.spine.skeleton.color = {r: 0, g: 0, b: 0, a: .1};

        let coin = this.addSpine(530, 190, "coin", "flipForward", true);
        this.coinAnim = coin.play("flipForward", false).timeScale = 3;
        coin.setSkin(coinData.key);
        coin.spine.setDepth(depth);

        this.addSquareMask([coin.spine, coinShadow.spine], 435, 100, 200, 200, false);
        coin.spine.mask.invertAlpha = true;
        
        this.addTween(coin.spine, 400, {y: 60}, Phaser.Math.Easing.Sine.Out, ()=>{
            coin.spine.mask = null;
            coinShadow.spine.mask = null;
            this.addTween(coinShadow.spine.skeleton.color, 1500, {a: .5}, Phaser.Math.Easing.Sine.Out);
            this.addTween(coinShadow.spine, 1500, {y: coinData.y + 5, x: coinData.x + 10, scaleX: coinData.scale, scaleY: coinData.scale, easeParams: [1, 1]}, "Bounce");
            this.addTween(coin.spine, 1500, {y: coinData.y, x: coinData.x, scaleX: coinData.scale, scaleY: coinData.scale, easeParams: [1, 1]}, "Bounce", ()=>{
            });
        });
    }
}